import React, { Component } from 'react'
import renderContent from '../../utilities/renderContent'
import './style.css'
import imgPortrait from './portrait.png'
import imgMain from './about.jpg'
import { Parallax } from 'react-parallax';
import image1 from './world-allergy-day-2017/1.jpg'
import image2 from './world-allergy-day-2017/2.png'
import image3 from './world-allergy-day-2017/3.jpg'
import image4 from './Malaysian-Urticaria-Expert-Group/1.jpg'
import image5 from './healthcare-update-for-pharmacists/1.jpg'
import image6 from './healthcare-update-for-pharmacists/2.jpg'
import image7 from './skin-cancer-surgery-mohs/1.jpg'
import image8 from './skin-cancer-surgery-mohs/2.gif'
import image9 from './skin-cancer-surgery-mohs/3.jpg'

class About extends Component {
  render() {
    return (
      <div className="about">
        <div className="page-bg">
          <Parallax bgImage={imgMain} strength={400} className="page-parallax">
          </Parallax>
        </div>
        <div className="container container-parallax" style={{ paddingBottom: '2rem' }}>
          <div className="parallax-container">
            <div className="row">
              <div className="left" style={{ alignSelf: 'flex-start' }}>
                <img src={imgPortrait} className="image-portrait" draggable="false" alt="Dr Adrian Yong" />
              </div>
              <div className="right">
                <div className="about-title">About</div>
                <div className="about-quotes">
                  <p>
                    Associate Professor Dr Adrian Yong Sze Wai is a Consultant Dermatologist & Dermatological Surgeon.
                    {/* Having returned from the United Kingdom under the Talentcorp programme in 2015, he held the position of Associate Professor in the Faculty of Medicine, University Malaya and Head of the Division of Dermatology at the University Malaya Medical Centre, Kuala Lumpur, Malaysia.
                    He was also appointed by Malaysia’s Director-General of Health as a committee member of the Main Credentialing and Privileging Committee of Aesthetic Medical Practice (LCP committee), Ministry of Health Malaysia. */}
                  </p>
                  <p>
                    Dr Adrian Yong chose Dermatology as his specialty early on in his career as a final year medical student in London.
                    Dermatology captivated his interest due to the unique combination of both medical specialty diagnostics and surgical procedures both complementing one another to treat a wide range of skin disorders.
                  </p>
                </div>
              </div>
            </div>

            <div className="part2">
              <h3>Royal Free and University College Medical School, London, UK</h3>
              <p>
                A/Professor Yong obtained his medical degree from the prestigious Royal Free and University College Medical School, London, UK.
                He subsequently completed his internal medicine specialist training and obtained his Membership of the Royal College of Physicians.
                {/* Shortly after, through a competitive selection process, he successfully joined the highly sought-after dermatology specialty training program. A/Professor Yong gained valuable insight and experience through working in eminent hospitals in Cambridge, London and Norwich. He then worked as a Consultant Dermatologist, focusing on cosmetic and surgical dermatology and cutaneous allergy in the UK. During his tenure as Head of Dermatology in University Malaya Medical Centre, A/Professor Yong pioneered Mohs micrographic surgery in Malaysia and assisted in the setting up of a patch test and phototherapy service. */}
              </p>
              {/* <h3>Expert Reviewer in International Journals</h3>
              <p>
              In addition to having published articles in numerous international journals, A/Professor Yong is an expert reviewer for the reputable British Journal of Dermatology and Clinical and Experimental Dermatology in the UK and the Malaysian Journal of Dermatology in Malaysia. He has been invited to speak at government state-organised exposition and National Dermatological Society meetings on Mohs and reconstructive surgery in the management of skin cancer. A/Professor Yong has spoken at numerous national and international allergy forums and is the Chairperson and key opinion leader as appointed by Menarini in the management of chronic urticaria in Malaysia. In addition, he is a highly sought-after speaker at both public and healthcare professional workshops on itching, acne, eczema and psoriasis.
              </p> */}
              <h3>Beliefs & Passion</h3>
              <p>
                He is always happy to share his passion with both members of the public and healthcare professionals. A/Professor Yong firmly believes in the delivery of effective and safe aesthetic treatments.
                {/* hence his contributions to the Main Credentialing and Privileging Committee of Aesthetic Medical Practice, Ministry of Health Malaysia. */}
              </p>
              {/* <p>
              Dr Yong is very grateful for the privilege of having served a wide range of Dermatology patients both in the United Kingdom and in Malaysia. The demographics of cases vary widely from skin cancers and rosacea in the UK to tropical skin infections, skin allergy and pigmentary disorders in Malaysia. Caseload for a typical Dermatological Surgeon in the UK comprises six surgeries a day and four MOHs micrographic surgery cases to remove skin cancers in a week. In Malaysia, the diversity of cases is greater ranging from skin cancer to skin infections and inflammatory skin conditions and a considerable number of pigment disorders.
              </p> */}
              <p>
              Dr Yong’s priority is providing his patients with the most up-to-date, evidenced-based diagnostics and treatment, customised to his patient’s aims, expectations, budget and personal values. Dr Yong actively encourages his patients to be very open and communicate their concerns and problems beyond the skin disease that they have so that their overall quality of life can be improved through targeted treatment to achieve fast and effective treatments.
              </p>
            </div>

            <div className="about-bottom-content">

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/components/About/index.js